<i18n lang="yaml">
  pt:
    seeAll: "ver todos"
</i18n>

<template>
  <nav class="customselect cursor-pointer p-relative">
    <div
      data-grid="column"
      class="customselect__wrapper grid--between p-2 w-100 h-100 p-relative border-radius-1 border-1 overflow-hidden"
    >
      <h6 class="customselect__storename text-uppercase overflow-hidden w-75 m-0">
        {{ getApp.name }}
      </h6>

      <h4 class="customselect__platform m-0 text-uppercase">
        {{ getApp.type }}
      </h4>

      <span
        data-grid
        class="customselect__arrow grid--va-center grid--center p-absolute"
      >
        <ArrowDownIcon class="w-100 h-100" />
      </span>
    </div>

    <ul class="customselect__applist w-100 p-absolute border-radius-1">
      <li class="customselect__appitem text-uppercase">
        <router-link
          to="/"
          data-grid
          class="grid--va-center h-100 px-2"
        >
          {{ $t('seeAll') }}
        </router-link>
      </li>

      <li
        v-for="app in getApps.list"
        :key="app.id"
        :title="app.name"
        class="customselect__appitem text-uppercase"
      >
        <a
          data-grid
          class="grid--va-center grid--between h-100 px-2"
          :href="`/checklist/${app.id}`"
        >
          <span class="customselect__label overflow-hidden">
            {{ app.name }}
          </span>

          <ArrowDownIcon />
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>
import { defineComponent } from 'vue'
import { mapActions, mapGetters } from 'vuex'

import ArrowDownIcon from '../../icons/ArrowDownIcon'

export default defineComponent({
  name: 'CustomProductsSelection',

  components: {
    ArrowDownIcon
  },

  computed: {
    ...mapGetters({
      getApp: 'apps/getApp',
      getApps: 'apps/getApps'
    })
  },

  async mounted () {
    await this.searchApps({ page: 1, per_page: 200 })
  },

  methods: {
    ...mapActions({
      searchApps: 'apps/searchApps'
    })
  }
})
</script>

<style lang="scss" scoped>
  .customselect {
    width: 180px;
    height: 55px;

    &:hover > ul {
      max-height: 144px;
      box-shadow: 0 0 20px -7px rgba(var(--gray1), .9);
    }

    &__wrapper {
      background-color: var(--primary);
      border: 1px solid rgba(var(--white), .5);

      .is-dark-theme & {
        border-color: transparent;
        background-color: rgb(var(--black1));
      }
    }

    &__storename {
      white-space: nowrap;
      text-overflow: ellipsis;

      color: rgb(var(--gray7));
      font: 700 1rem "Nunito", sans-serif;

      .is-dark-theme & {
        color: rgb(var(--gray4));
      }
    }

    &__platform {
      color: rgb(var(--white));
      font: 600 1.2rem "Nunito", sans-serif;
    }

    &__arrow {
      color: rgb(var(--white));
      width: 12px;
      height: 12px;

      top: 50%;
      right: 7px;
      transform: translateY(-50%);
    }

    &__applist {
      left: 0;
      top: 100%;

      height: 144px;
      max-height: 0;
      min-width: 180px;

      overflow: hidden scroll;
      transition: all .4s ease-in-out;
      background-color: rgba(var(--white), 0.51);

      -webkit-backdrop-filter: blur(7px);
              backdrop-filter: blur(7px);

      .is-dark-theme & {
        background-color: rgb(var(--black1));
      }

      &::-webkit-scrollbar {
        width: 5px;
        background-color: rgb(var(--white));
      }

      &::-webkit-scrollbar-thumb {
        background-color: var(--primary-dark);
      }
    }

    &__appitem {
      height: 36px;

      &:hover a,
      a.router-link-active {
        background-color: rgb(var(--gray7));
      }

      a {
        text-overflow: ellipsis;
        color: var(--primary-dark);
        font: 600 1.2rem "Nunito", sans-serif;
        transition: .2s ease-in-out;

        .is-dark-theme & {
          color: rgb(var(--gray6));

          &:hover {
            background-color: rgb(var(--gray8));
          }
        }

        svg {
          width: 10px;
          height: 10px;
          transform: rotate(-90deg);
        }
      }
    }

    &__label {
      width: 90%;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
</style>
